import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  HeadingDisplay,
  BaseText,
  Link,
  ContentDisplay,
  DataTable,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';
import { TutorialModal } from '../TutorialModal';

import balanceTutorialDark from '@/assets/imgs/margin-allocation/balance-tutorial-dark.png';
import balanceTutorialLight from '@/assets/imgs/margin-allocation/balance-tutorial-light.png';

import {
  IMarginAllocation,
  IMarginAllocationPreview
} from '@/modules/trade/services/margin-allocation';

import {
  EMarginAllocationSteps,
  formattedData
} from '@/modules/trade/views/MarginAllocation/helpers';

interface IDataForm {
  isUpdatingLimits: boolean;
  drawdown: { value: number; formatted: string };
  balance: { value: number; formatted: string };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Balance',
  setup(__props) {

const router = useRouter();

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<IDataForm>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocation>;
const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreview>;

const isTutorialModalOpen = ref(false);
const balanceFormatted = ref('');
const balanceValue = ref(0);
const drawdown = ref(0);

const tableColumns = [
  {
    label: 'Ativo',
    align: 'left',
    getter: 'ticker'
  },
  {
    label: 'Exposição máxima',
    align: 'right',
    getter: 'maxExpose'
  }
];

const tableData = computed(() => {
  return formattedData(
    marginAllocationPreview.value.variationTable,
    balanceValue.value
  );
});

const tutorialModalData = {
  title: 'Limites Day Trade',
  src: {
    dark: balanceTutorialDark,
    light: balanceTutorialLight
  },
  subtitle: 'Defina seu saldo alocado e prejuízo máximo.',
  buttonLabel: 'Começar'
};

const isDisabled = computed(() => {
  return balanceValue.value < 100 || status.value === 'error';
});

const availableBalance = computed(() => {
  return marginAllocationPreview.value.availableAmount.value;
});

const status = computed(() => {
  const minAllocation = 100;

  if (balanceValue.value > 0 && balanceValue.value < minAllocation) {
    return 'error';
  }

  return balanceValue.value > availableBalance.value ? 'error' : '';
});

const helperText = computed(() => {
  const minAllocation = 100;

  if (balanceValue.value > 0 && balanceValue.value < minAllocation) {
    return 'Valor mínimo para alocação é R$ 100,00.';
  }

  return balanceValue.value > availableBalance.value
    ? `Valor superior ao saldo disponível ${marginAllocationPreview.value.availableAmount.formatted}`
    : `Saldo disponível ${marginAllocationPreview.value.availableAmount.formatted}`;
});

const isFirstTime = computed(() => {
  return marginAllocation.value.isFirstTime;
});

const initialValue = computed(() => {
  return dataForm.value.balance.formatted;
});

function goToTerms() {
  window.open(marginAllocationPreview.value.termsLink, '_blank');
}

function goToPolicy() {
  window.open(marginAllocationPreview.value.policyLink, '_blank');
}

function onChangeValue(data: { value: number; formatted: string }) {
  balanceFormatted.value = data.formatted;
  balanceValue.value = data.value;
}

function nextStep() {
  updateDataForm('balance', {
    value: balanceValue.value,
    formatted: balanceFormatted.value
  });

  changeStep(EMarginAllocationSteps.DRAWDOWN);
}

function handleBack() {
  if (marginAllocation.value.isFirstTime) router.push({ name: 'trade' });

  changeStep(EMarginAllocationSteps.DAY_TRADE_LIMITS);
}

onMounted(() => {
  isTutorialModalOpen.value = isFirstTime.value;

  drawdown.value = dataForm.value.drawdown.value;
  balanceValue.value = dataForm.value.balance.value;
  balanceFormatted.value = dataForm.value.balance.formatted.replace('R$', '');
});

return { __sfc: true,router, changeStep, updateDataForm, dataForm, marginAllocation, marginAllocationPreview, isTutorialModalOpen, balanceFormatted, balanceValue, drawdown, tableColumns, tableData, tutorialModalData, isDisabled, availableBalance, status, helperText, isFirstTime, initialValue, goToTerms, goToPolicy, onChangeValue, nextStep, handleBack, NavBar, HeadingDisplay, BaseText, Link, ContentDisplay, DataTable, ButtonContainer, ButtonPrimary, BackButton, SingleInputMoney, TutorialModal }
}

})